import { render, staticRenderFns } from "./add-bank.vue?vue&type=template&id=25a41a1b&"
import script from "./add-bank.vue?vue&type=script&lang=js&"
export * from "./add-bank.vue?vue&type=script&lang=js&"
import style0 from "./add-bank.vue?vue&type=style&index=0&id=25a41a1b&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports